import { useGlobalContext } from "context/GlobalProvider"
import styles from './ListCustomers.module.scss';
import { FC, useEffect } from "react";
import { ReactComponent as CurrencyCircleDollarIcon } from "assets/CurrencyCircleDollar.svg";
import { Box, Loader } from "@mantine/core";
import useExternalApiService from "helpers/ExternalApiService";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { store } from 'stores/Store';

interface Props {
  onCustomerSelected: (c: any) => void;
}

const API_URL = process.env.REACT_APP_EAI_URL

const LatestPractitionersUpdatedList: FC<Props> = ({
  onCustomerSelected,
}) => {
  const { latestPractitionersUpdated: {
    fetchPractitioners,
    practitioners
  } } = useGlobalContext();
  const { postData } = useExternalApiService(API_URL);

  useEffect(() => {
    fetchPractitioners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPractitionerSelected = (practitionerId: string) => {
    postData('/api/get_practitioner_by_id', {
      practitioner_id: practitionerId
    }).then((response) => {
      if (response?.practitioner) {
        onCustomerSelected(response?.practitioner);
      }
    })
  }

  return (
    <Box>
      {practitioners === null ? (
        <Loader />
      ) : (
        <Box>
          {practitioners?.map((customer, index) => {
            const hasMtdYtd = (customer?.ytd_sales > 0 || customer?.mtd_sales > 0) && customer.data_source !== "PRACTITIONER_ACCOUNT_VIEW_NM";
            let dataSourcePillText: string | null = null;
            switch (customer.data_source) {
              case "PRACTITIONER_ACCOUNT_VIEW":
                dataSourcePillText = null; // no pill for this case
                break;
              case "PRACTITIONER_ACCOUNT_VIEW_NM":
                dataSourcePillText = "Badger";
                break;
              case "PRACTITIONER_DISTRIBUTOR_ACCOUNT_VIEW":
                switch (customer.name_dfh_channel) {
                  case "":
                    dataSourcePillText = `Dist`;
                    break;
                  case "DFH":
                    dataSourcePillText = `Dist: ${customer.name_dfh_channel}`;
                    break;
                  default:
                    dataSourcePillText = `${customer.name_dfh_channel}`;
                    break;
                }
                break;
              default:
                dataSourcePillText = null;
            }
            return (
              <div
                className={styles.customer}
                key={customer.id}
                onClick={() => onPractitionerSelected(customer?.id)}
              >
                <div className={styles.leftWrapper}>
                  {/*<div className={styles.nameRow}>*/}
                  <div className={styles.counterColumn}>
                    <span className={styles.practitionerCounter}>
                      {`${index + 1}.`}
                    </span>
                  </div>
                  <div className={styles.leftColumn}>
                    <span className={styles.practitionerName}>
                      {customer.primary_name ?? customer.name ?? customer.companyname ?? "(Unnamed practitioner)"}
                    </span>
                    <span className={styles.category}>{customer.specialty}</span>
                  </div>
                </div>
                <div className={styles.rightColumn}>
                  {hasMtdYtd && (
                    <CurrencyCircleDollarIcon className={styles.dollarIcon} />
                  )}
                  {/*
                  2) If this practitioner has a "data source pill," render it here.
                     It will inherit CSS from .dataSourcePill (red background, white text, rounded).
                */}
                  {
                    customer.tags?.filter((tag: any) => tag.selected === true).length > 0 ?
                      <div style={{ backgroundColor: "#FF9D00" }} className={styles.dataSourcePill}>
                        {(() => {
                          const tagName = customer.tags?.filter((tag: any) => tag.selected === true)[0]?.name;
                          return tagName?.length > 10 ? `${tagName.substring(0, 10)}...` : tagName;
                        })()}
                      </div>
                      : null
                  }
                  {dataSourcePillText && (
                    <div className={styles.dataSourcePill}>
                      {dataSourcePillText}
                    </div>
                  )}

                </div>

                {customer.status === "LEAD-INCOMPLETE" && (
                  <div className={styles.leadFlag}>
                    <span>LEAD</span>
                  </div>
                )}
                {customer.status === "LEAD-READY2SUBMIT" && (
                  <div className={styles.leadFlagComplete}>
                    <span>LEAD</span>
                  </div>
                )}

                {/*<p className={styles.category}>{customer.specialty}</p>*/}
              </div>
            )
          })}
        </Box>
      )}
    </Box>
  );
};

export default LatestPractitionersUpdatedList;